export default __webpack_public_path__ + "static/media/System Architecture.44fe7eab.png";